import { Component, OnInit } from '@angular/core';
import { LoginService } from '../_services/login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LogIn } from '../_models/log-in';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { CookieService } from '../../../node_modules/ngx-cookie-service';
import { JsonpClientBackend } from '../../../node_modules/@angular/common/http';
import { ValidationErrorMessage } from '../constants/validation';
import { WhiteSpaceValidators } from '../shared/white-space-validator';
import { SnotifyService, SnotifyPosition } from '../../../node_modules/ng-snotify';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  logInFormGroup: FormGroup;
  logInDataForm: LogIn = new LogIn();
  response: any; 
  public loading : boolean = false;
  

  constructor(private logInService:LoginService,
    private formbuilder: FormBuilder,
  private router:Router,
  private snotifyService:SnotifyService,
private cookie:CookieService) { }



  ngOnInit() {
    this.loginFormValidate();
    console.log("In Login")
     // confirmPassword: ['', [Validators.required, this.compareValidator('password')]],
  }

   loginFormValidate(){
    const emailPattern = "[[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.logInFormGroup = this.formbuilder.group({
      emailId: ['', [Validators.required, Validators.pattern(emailPattern)]],
      password: ['', Validators.required]
    });
    }
  onLogin(){
    
    if (this.logInFormGroup.valid) {
      this.loading = true; 
      this.logInFormGroup.disable(); 
      this.logInDataForm.email = this.logInFormGroup.get('emailId').value;
      this.logInDataForm.hashPassword = btoa(this.logInFormGroup.get('password').value);
      this.logInDataForm.applicationName='HomeFabrics';
      this.logInDataForm.channelId='HF';
      this.logInDataForm.clientName='Mayuratech';
      this.loading = true;
      this.logInService.login(this.logInDataForm).subscribe(resp=>{
        this.loading = true;
        this.response=resp;
        if(resp.status===200){
          this.loading = true;
          sessionStorage.setItem('token',resp.headers.get("Authorization"));
          
        this.cookie.set('UserId',this.response.body.responseData.appUserId)
        console.log(this.response.body.responseData.appUserId);
        this.cookie.set('UserRole',this.response.body.responseData.appUserRole)
        var UserRole=this.cookie.get('UserRole')
        console.log(UserRole);
        setTimeout(() => {
          this.loading = false;
        }, 20000); 
        // this.router.navigateByUrl('/aboutus'); 
        // window.location.href = "/homefabrics/";
         this.router.navigate(['/home']);
        }
        
        this.logInFormGroup.reset();
        
      },
      (error: any) => {
        if (error.status == 500){
         // window.alert("User Id Already Exists")
         this.loading = false;
           let msg = "Incorrect credentials"
           let action = ''
           this.snotifyService.error(msg, action, {
             timeout: 3000,
             showProgressBar: true,
             closeOnClick: true,
             pauseOnHover: true,
             position: SnotifyPosition.rightBottom
          })
        }
      })
      
    }
    
  }

   /*---Error Message for eMail---*/
   getErrorMsgForLoginFormEmail() {
    return this.logInFormGroup.controls.emailId.errors.required ? ValidationErrorMessage.REQUIRED :
      this.logInFormGroup.controls.emailId.errors.pattern ? ValidationErrorMessage.VALID_EMAIL :
          '';
  }
  
  // /*---Error Message for Password---*/
  // getErrorMsgForPassword() {
  //   return this.logInFormGroup.controls.password.errors.required ? ValidationErrorMessage.REQUIRED :
  //    this.logInFormGroup.controls.password.errors.minlength ? ValidationErrorMessage.MIN_LENGTH_FOUR :
  //    this.logInFormGroup.controls.password.errors.maxlength ? ValidationErrorMessage.MAX_LENGTH_FIFTEEEN :
  //     this.logInFormGroup.controls.password.errors.whitespace ? ValidationErrorMessage.REQUIRED :
  //       '';
  // }

  /*---Error Message for password---*/
  getErrorMsgForLoginFormPassword() {
    return this.logInFormGroup.controls.password.errors.required ? ValidationErrorMessage.REQUIRED : '';
  }

}
